import { NgIf } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { IconsModule } from "@progress/kendo-angular-icons";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { kpiStatusOpenIcon, SVGIcon } from "@progress/kendo-svg-icons";

import { QueryPanelConnectorService } from 'src/app/modules/fwcore/services';
import { QueryPanelSummaryItem } from 'src/app/modules/fwcore/models';

@Component({
  selector: 'checkbox-criteria',
  standalone: true,
  styleUrls: ['./checkbox-criteria.component.scss'],
  templateUrl: './checkbox-criteria.component.html',
  imports: [IconsModule, InputsModule, LabelModule, NgIf]
})

export class CheckboxCriteriaComponent
  implements OnInit, OnDestroy {
  /*-------------------------- Input / Output ------------------*/
  @Output() get value(): boolean {
    return this.checkValue;
  }
  @Input() set default(val: boolean) {
    this.value = val;
  }

  public set value(val: boolean) {
    if (this.checkValue != val) {
      let item = new QueryPanelSummaryItem();
      item.controlName = this.caption;
      item.text = this.caption;
      item.id = "0";

      if (val) {
        this.checkValue = true;
        this.connectorService.addItem(item, false);
      } else {
        this.checkValue = false;
        this.connectorService.removeItem(item, false);
      }
    }
  }

  @Input() caption: string = "";
  @Input() queryStringParameter?: string;
  // default icon to the "user" icon
  @Input() svgIcon?: SVGIcon = kpiStatusOpenIcon;

  /* ------------------------ Internal properties ------------------------ */
  protected checkValue: boolean = false;
  protected subscription: any;

  /* ------------------------ Constructor ------------------------ */
  constructor (
    protected connectorService: QueryPanelConnectorService,
    private readonly route: ActivatedRoute) {
    this.subscription = this.connectorService.onMessage().subscribe(message => {
      if (message) {
        switch (message.type) {
          case "clear":
            this.checkValue = false;
            break;
          case "load":
            this.connectorService.isLoaded("_");
            break;
          case "delete":
            if (message.item?.controlName == this.caption) {
              this.checkValue = false;
            }
        }
      }
    });
  }

  /* ------------------------ ng ------------------------ */
  ngOnInit(): void {
    if (this.queryStringParameter &&
      this.route.snapshot.queryParamMap.has(this.queryStringParameter)) {
      let result = this.route.snapshot.queryParamMap.get(this.queryStringParameter);
      if (result) {
        if (
          (result == "1") ||
          (result.localeCompare("true", undefined, { sensitivity: "accent" }) == 0)
        ) {
          this.checkValue = false;
          this.onChange();
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  /* ------------------------ event handlers ------------------------ */
  onChange() {
    this.value = !this.value;
  }
}
